import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type LoginRedirectStore = {
  redirectDestination: string | null;
  setRedirectDestination: (destination: string | null) => void;
  fetchRedirectDestination: () => string | null;
};

export const useLoginRedirectStore = create<LoginRedirectStore>()(
  persist<LoginRedirectStore>(
    (set, get) => ({
      redirectDestination: null,
      setRedirectDestination: (destination: string | null) => set(() => ({ redirectDestination: destination })),
      fetchRedirectDestination: () => {
        const value = get().redirectDestination;
        set(() => ({ redirectDestination: null }));
        return value;
      },
    }),
    {
      name: "login-redirect",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
